
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
import CrossIconNew from "@/components/icons/CrossIconNew.vue";

@Component({
  components: {
    ModalFullScreen,
    CrossIconNew,
  },
})
export default class InvoiceDashboard extends Vue {
  @Prop({ type: String, required: true }) readonly message!: string;
}
